import { getEntityById, getLabelFromId } from '@core/utils/collection';
import { idToForm, optionalNumber, toFormValue } from '@core/utils/form';
import type { CreateMitreItemData, MitreItem } from '../../../../api/order';
import { VestmentCategory } from '../../../enum/vestmentCategory';
import { SIZE_FIELDS_BY_VESTMENT_CATEGORY } from '../../size';
import {
  EMPTY_LINE_ITEM_BASE,
  baseFieldsFromApi,
  baseLineItemPayload,
  fabricSegment,
  formatOrderItemSizeParts,
  getMaterialSummary,
  segment,
  segments,
} from '../helpers';
import type { MitreItemFormValues, OrderItemCategoryConfig } from '../types';

export const mitreConfig: OrderItemCategoryConfig = {
  label: 'Mitre',
  emptyFormValues: (): MitreItemFormValues => ({
    ...EMPTY_LINE_ITEM_BASE,
    head: '',
    bodyFabric: '',
    bodyColor: '',
    panelFabric: '',
    panelColor: '',
    liningFabric: '',
    liningColor: '',
    tassel: '',
  }),
  apiToFormValues: (item): MitreItemFormValues => {
    const mitre = item as MitreItem;
    return {
      ...baseFieldsFromApi(mitre),
      head: toFormValue(mitre.head),
      bodyFabric: idToForm(mitre.bodyFabric),
      bodyColor: idToForm(mitre.bodyColor),
      panelFabric: idToForm(mitre.panelFabric),
      panelColor: idToForm(mitre.panelColor),
      liningFabric: idToForm(mitre.liningFabric),
      liningColor: idToForm(mitre.liningColor),
      tassel: idToForm(mitre.tassel),
    };
  },
  formToPayload: (item): CreateMitreItemData => {
    const mitre = item as MitreItemFormValues;
    return {
      ...baseLineItemPayload(mitre),
      head: optionalNumber(mitre.head),
      bodyFabric: optionalNumber(mitre.bodyFabric),
      bodyColor: optionalNumber(mitre.bodyColor),
      panelFabric: optionalNumber(mitre.panelFabric),
      panelColor: optionalNumber(mitre.panelColor),
      liningFabric: optionalNumber(mitre.liningFabric),
      liningColor: optionalNumber(mitre.liningColor),
      tassel: optionalNumber(mitre.tassel),
    };
  },
  formatSummarySegments: (item, ctx) => {
    const mitre = item as MitreItemFormValues;

    return segments(
      segment(
        'Size',
        ...formatOrderItemSizeParts(
          SIZE_FIELDS_BY_VESTMENT_CATEGORY[VestmentCategory.Mitre],
          {
            sizeName: getLabelFromId(ctx.sizes, mitre.size),
            size: getEntityById(ctx.sizes, mitre.size),
            customer: ctx.customer,
            head: mitre.head,
          }
        )
      ),
      fabricSegment(
        'Body',
        ctx.fabrics,
        ctx.colors,
        mitre.bodyFabric,
        mitre.bodyColor
      ),
      fabricSegment(
        'Panel',
        ctx.fabrics,
        ctx.colors,
        mitre.panelFabric,
        mitre.panelColor
      ),
      fabricSegment(
        'Lining',
        ctx.fabrics,
        ctx.colors,
        mitre.liningFabric,
        mitre.liningColor
      ),
      segment('Tassel', getMaterialSummary(ctx.tassels, mitre.tassel))
    );
  },
};
